document.addEventListener("DOMContentLoaded", () => {
  
  // 1. FUNZIONE: Calcola la data di consegna stimata e aggiorna i campi
  function calculateDeliveryDate() {
    const dateArray = ["2025-12-22","2025-12-23","2025-12-24","2025-12-25","2025-12-26","2025-12-27","2025-12-28","2025-12-29","2026-01-01","2026-01-06"];
    let tempbase = 48;
    let dataCorrente = new Date();
    
    function converter(dataIniziale) {
      const data = new Date(dataIniziale);
      const anno = data.getFullYear();
      const mese = (data.getMonth() + 1).toString().padStart(2, '0');
      const giorno = data.getDate().toString().padStart(2, '0');
      return `${anno}-${mese}-${giorno}`;
    }

    function isDateBetween(dateToCheck, startDate, endDate) {
      return new Date(dateToCheck) >= new Date(startDate) && new Date(dateToCheck) <= new Date(endDate);
    }

    function countDatesPresent(dates, startDate, endDate) {
      let count = 0;
      for (const date of dates) {
        if (isDateBetween(date, startDate, endDate)) count++;
      }
      return count;
    }

    let hrs = dataCorrente.getHours();
    let day = dataCorrente.getUTCDay();
    let millisecondsPerHour = 3600000;
    
    let pre12 = hrs < 12;
    let premerc = (day < 3 && day != 0);

    if (dataCorrente.getUTCDay() == 6) { 
      dataCorrente = new Date(dataCorrente.getTime() + (48 * millisecondsPerHour));
      pre12 = true; premerc = true;
    } else if (dataCorrente.getUTCDay() == 0) { 
      dataCorrente = new Date(dataCorrente.getTime() + (24 * millisecondsPerHour));
      pre12 = true; premerc = true;
    } 

    if (!pre12) tempbase += 24;

    let totalMilliseconds = tempbase * millisecondsPerHour;
    let ordDate = new Date(dataCorrente.getTime() + totalMilliseconds);
    let tempbase2 = !premerc ? tempbase + 48 : tempbase;

    let prevDate = new Date(dataCorrente.getTime() + (tempbase2 * millisecondsPerHour));
    const numeroDatePresenti = countDatesPresent(dateArray, dataCorrente, prevDate);

    for (let i = 0; i < numeroDatePresenti; i++) {
      prevDate = new Date(prevDate.getTime() + (24 * millisecondsPerHour)); 
    }
    
    let spedDate;
    if (prevDate.getUTCDay() == 6) spedDate = new Date(prevDate.getTime() + (48 * millisecondsPerHour)); 
    else if (prevDate.getUTCDay() == 0) spedDate = new Date(prevDate.getTime() + (24 * millisecondsPerHour)); 
    else spedDate = prevDate;

    for (const date of dateArray) {
      if (converter(new Date(date)) == converter(spedDate)) {
        spedDate = new Date(spedDate.setDate(spedDate.getDate() + 1));
      }
    }

    const options = { day: "numeric", month: "long" };
    const formattedDate = spedDate.toLocaleDateString("it-IT", options);
    
    // Aggiorna tutti gli elementi con classe .data-cns
    document.querySelectorAll(".data-cns").forEach(el => {
      if (el.innerText !== formattedDate) {
        el.innerHTML = formattedDate;
      }
    });
  }

  // 2. FUNZIONE: Controlla le giacenze per il tema Hyper (Pagina Prodotto)
  function checkHyperAvailability() {
  // 1. Controllo integrità dati
  if (!window.productInventory) return;

  const skuElement = document.querySelector('.product__sku');
  const dataNode = document.getElementById('delivery-logic-data');
  if (!skuElement || !dataNode) return;

  // 2. Recupero parametri (isExplicit gestisce la logica dei gg > 8 o metafield offerta)
  const isExplicit = dataNode.getAttribute('data-is-explicit') === 'true';
  
  // Pulizia SKU per tema Hyper: estrae il codice pulito dopo "SKU:"
  const currentSku = skuElement.innerText.split(':').pop().trim();
  
  const qtyElement = document.querySelector('.quantity__input');
  const currentQty = qtyElement ? parseInt(qtyElement.value, 10) : 1;

  // 3. Ricerca variante attiva nell'inventario
  const productData = window.productInventory.find(p => p.sku === currentSku);
  if (!productData) return;

  // Riferimenti ai badge HTML
  const b1 = document.querySelector('.dispbx-prd-1'); // Disponibile Pronta Consegna
  const b2 = document.querySelector('.dispbx-prd-2'); // Preordine o Sped. Differita
  const b3 = document.querySelector('.dispbx-prd-3'); // Quantità Mista
  const qAvl = document.querySelector('.prd-qty-avl'); // Span per pezzi disponibili

  // 4. RESET TOTALE: Nascondi tutti i badge di base
  if (b1) b1.style.display = 'none';
  if (b2) b2.style.display = 'none';
  if (b3) b3.style.display = 'none';

  // --- 5. LOGICA DI ATTIVAZIONE ---

  // CASO ZERO: Se il prodotto è stock 0 (o meno) e la policy è 'deny' (NON VENDIBILE), 
  // usciamo subito. I badge rimangono tutti nascosti.
  if (productData.av <= 0 && productData.policy === 'deny') {
    return; 
  }

  // CASO A: Disponibilità immediata a magazzino per l'intera quantità richiesta
  if (currentQty <= productData.av && productData.av > 0) {
    if (b1) b1.style.display = 'block';
  } 
  
  // CASO B: Quantità richiesta superiore allo stock MA prodotto vendibile (Policy Continue)
  else if (productData.policy === 'continue' || productData.available === true) {
    
    // B1. Stock parziale (Misto: es. ho 1 pezzo, ne chiedi 3)
    if (productData.av > 0) {
      if (b3) {
        b3.style.display = 'block';
        if (qAvl) qAvl.innerText = productData.av;
      }
    } 
    // B2. Stock zero o negativo (Preordine Totale / Spedizione differita)
    else {
      if (b2) b2.style.display = 'block';
    }
  }
}
  // 3. MONITORAGGIO DOM PER CART DRAWER (MutationObserver)
  const cartContainer = document.querySelector('cart-drawer, #CartDrawer');
  if (cartContainer) {
    const observer = new MutationObserver(() => {
      // Quando il carrello cambia, attendiamo un istante e ricalcoliamo la data
      setTimeout(calculateDeliveryDate, 300);
    });
    observer.observe(cartContainer, { childList: true, subtree: true });
  }

  // 4. ESECUZIONE INIZIALE
  calculateDeliveryDate();
  setTimeout(checkHyperAvailability, 200);

  // Ascolta i cambiamenti di quantità o varianti nella pagina prodotto
  document.addEventListener('change', function(event) {
    if (event.target.closest('product-info') || event.target.classList.contains('quantity__input')) {
      setTimeout(checkHyperAvailability, 300);
    }
  });

});